import { render, staticRenderFns } from "./PropertyTileChip.vue?vue&type=template&id=232a6f63"
import script from "./PropertyTileChip.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyTileChip.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports